import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { SkillPracticeTaskStatus } from '../../../models/skill-learning.model';
import {
  SKILL_PRACTICE_STATUS_LABELS,
  SKILL_PRACTICE_TASK_STATUS,
} from '../../../options/skill-learning.option';

type SkillPracticeTaskStatusInput = SkillPracticeTaskStatus | null;
const RECIPIENT_PROFILE_ROUTE = '/dashboard/profile';

@Component({
  selector: 'app-practice-task-status',
  templateUrl: './practice-task-status.component.html',
  styleUrls: ['./practice-task-status.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PracticeTaskStatusComponent {
  readonly taskStatuses = SKILL_PRACTICE_TASK_STATUS;
  readonly recipientProfileRoute = RECIPIENT_PROFILE_ROUTE;

  @Input() taskStatus: SkillPracticeTaskStatusInput = null;
  @Input() curatorName: string | null = null;
  @Input() curatorPhone: string | null = null;
  @Input() recipientUserId: string | null = null;
  @Input() planfixTaskId: number | null = null;
  @Input() planfixTaskUrl: string | null = null;
  @Input() recreateAvailableAt: string | null = null;

  get hasCurator(): boolean {
    return !!this.curatorName || !!this.curatorPhone;
  }

  get hasPlanfixTaskLink(): boolean {
    return !!this.planfixTaskUrl;
  }

  get statusLabel(): string {
    if (!this.taskStatus) {
      return '';
    }
    return SKILL_PRACTICE_STATUS_LABELS[this.taskStatus] || '';
  }

  get shouldShowRecreateAvailableAt(): boolean {
    return this.taskStatus === SKILL_PRACTICE_TASK_STATUS.CANCELLED && !!this.recreateAvailableAt;
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/skill-learning/components/user/practice-level/practice-task-status.component.ts